/** CRM: contacts, lists, properties, companies, tags, notes. */
export default [

  {
    path: '/contacts',
    name: 'Contacts',
    component: () => import('@/views/private/ContactsView.vue'),
    meta: {
      public: false,
      title: 'Contacts',
    },
  },

  {
    path: '/contact/:contactId',
    name: 'Contact',
    component: () => import('@/views/private/ContactView.vue'),
    props: function(route) {
      return {
        contactId: Number(route.params.contactId),
      };
    },
    meta: {
      public: false,
      title: 'Contact',
    },
  },

  {
    path: '/contacts-import',
    name: 'Contacts Import',
    component: () => import('@/views/private/ContactsImportView.vue'),
    meta: {
      public: false,
      title: 'Contacts Import',
    },
  },

  {
    path: '/contact-lists',
    name: 'Contact Lists',
    component: () => import('@/views/private/ContactListsView.vue'),
    meta: {
      public: false,
      title: 'Contact Lists',
    },
  },

  {
    path: '/contact-list/:contactListId',
    name: 'Contact List',
    component: () => import('@/views/private/ContactListView.vue'),
    props: function(route) {
      return {
        contactListId: Number(route.params.contactListId),
      };
    },
    meta: {
      public: false,
      title: 'Contact List',
    },
  },

  {
    path: '/contact-properties',
    name: 'Contact Properties',
    component: () => import('@/views/private/ContactPropertiesView.vue'),
    meta: {
      public: false,
      title: 'Contact Properties',
    },
  },

  {
    path: '/companies',
    name: 'Companies',
    component: () => import('@/views/private/CompaniesView.vue'),
    meta: {
      public: false,
      title: 'Companies',
    },
  },

  {
    path: '/company/:companyId',
    name: 'Company',
    component: () => import('@/views/private/CompanyView.vue'),
    props: function(route) {
      return {
        companyId: Number(route.params.companyId),
      };
    },
    meta: {
      public: false,
      title: 'Company',
    },
  },

  {
    path: '/tags',
    name: 'Tags',
    component: () => import('@/views/private/TagsView.vue'),
    meta: {
      public: false,
      title: 'Tags',
    },
  },

  {
    path: '/tag/:tagId',
    name: 'Tag',
    component: () => import('@/views/private/TagView.vue'),
    props: function(route) {
      return {
        tagId: Number(route.params.tagId),
      };
    },
    meta: {
      public: false,
      title: 'Tag',
    },
  },

  {
    path: '/notes',
    name: 'Notes',
    component: () => import('@/views/private/NotesView.vue'),
    meta: {
      public: false,
      title: 'Notes',
    },
  },

  {
    path: '/note/:noteId',
    name: 'Note',
    component: () => import('@/views/private/NoteView.vue'),
    props: function(route) {
      return {
        noteId: Number(route.params.noteId),
      };
    },
    meta: {
      public: false,
      title: 'Note',
    },
  },

];
